import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import Button from "components/base/Button";
import { Select, Text } from "components/base/Form";
import { Alert } from "components/base/Toast";
import { useState } from "react";
import {
  DELETE_OBJECTIVE_KEY_RESULT,
  SAVE_OBJECTIVE_KEY_RESULT,
} from "./graphql";

const KeyResultForm = ({ originalKeyResult, objectiveId, hide }) => {
  const [description, setDescription] = useState(
    originalKeyResult?.description,
  );
  const [weight, setWeight] = useState(originalKeyResult?.weight);
  const [dueQuarter, setDueQuarter] = useState(originalKeyResult?.dueQuarter);
  const [notes, setNotes] = useState(originalKeyResult?.notes);

  let variables = { description, notes, dueQuarter, weight };

  if (originalKeyResult) {
    variables.id = originalKeyResult.id;
  } else if (objectiveId) {
    variables.objectiveId = objectiveId;
  }

  const [save, saveRes] = useMutation(SAVE_OBJECTIVE_KEY_RESULT, {
    variables,
    onCompleted() {
      Alert("success", "Key result saved successfully");
      hide();
    },
    onError(error) {
      Alert("error", parseError(error));
    },
  });

  const [deleteKeyResult, deleteKeyResultRes] = useMutation(
    DELETE_OBJECTIVE_KEY_RESULT,
    {
      onCompleted() {
        Alert("success", "Key result deleted successfully");
      },
      onError(error) {
        Alert("error", parseError(error));
      },
    },
  );

  function deleteHandler() {
    if (window.confirm("Are you sure you want to delete this key result?")) {
      hide();
      deleteKeyResult({
        variables: { id: originalKeyResult.id },
      });
    }
  }

  return (
    <div className="text-sm">
      <div className="space-y-3">
        <div>
          <label>Description:</label>
          <Text
            className="mt-2"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </div>

        <div className="flex items-center space-x-3">
          <label>Due Quarter:</label>
          <Select
            value={dueQuarter}
            onChange={(e) => setDueQuarter(e.target.value)}
          >
            <option value="1">Q1</option>
            <option value="2">Q2</option>
            <option value="3">Q3</option>
            <option value="4">Q4</option>
          </Select>

          <label>Weight:</label>
          <Select value={weight} onChange={(e) => setWeight(e.target.value)}>
            <option value="1">🐠</option>
            <option value="2">🐠🐠</option>
            <option value="3">🐠🐠🐠</option>
            <option value="4">🐠🐠🐠🐠</option>
            <option value="5">🐠🐠🐠🐠🐠</option>
          </Select>
        </div>

        <div>
          <label>Notes:</label>
          <Text
            className="mt-2"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </div>
      </div>

      <div className="mt-8 flex justify-between">
        <Button primary onClick={save} loading={saveRes.loading}>
          Save
        </Button>
        {originalKeyResult && (
          <Button
            danger
            onClick={deleteHandler}
            loading={deleteKeyResultRes.loading}
          >
            Delete Key Result
          </Button>
        )}
      </div>
    </div>
  );
};

export default KeyResultForm;
